import React from 'react';
import propTypes from 'prop-types';
import CSSReset, { GlobalFlexMain } from '@tds/core-css-reset';

import Footer from './footer';
import Layout from './layout';
import { setLocale, getLocale } from './utils';
import { LANG_ENGLISH } from './utils/constant';
import { Translations } from '../context/translations';
import { AppWrapper } from './design/css';

const App = ({ children }) => {
  const locale = getLocale();
  if (!locale || locale === 'null') setLocale(LANG_ENGLISH);

  return (
    <Translations>
      <AppWrapper>
        <CSSReset />
        <GlobalFlexMain />
        <Layout>{children}</Layout>
        {window.location.pathname !== '/confirmation' && <Footer />}
      </AppWrapper>
    </Translations>
  );
};

App.propTypes = {
  children: propTypes.node.isRequired
};

export default App;
